import { render, staticRenderFns } from "./SamTextarea.vue?vue&type=template&id=297ce4ba&scoped=true&"
import script from "./SamTextarea.vue?vue&type=script&lang=js&"
export * from "./SamTextarea.vue?vue&type=script&lang=js&"
import style0 from "./SamTextarea.vue?vue&type=style&index=0&id=297ce4ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ce4ba",
  null
  
)

export default component.exports